export default {"src":"/_next/static/media/check-gray.3e0b8777.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};